import React, { Component, Fragment } from 'react';
import capitalize from 'lodash/capitalize';
import forEach from 'lodash/forEach';
import get from 'lodash/get';
import unset from 'lodash/unset';
import size from 'lodash/size';
import keys from 'lodash/keys';

import Dialog from '@lightspeed/cirrus-dialog';

class TableBulkAction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedData: {},
      isOpen: false,
    };

    this.handleAllChange = this.handleAllChange.bind(this);
    this.handleSingleChange = this.handleSingleChange.bind(this);
    this.handleBulkActionConfirm = this.handleBulkActionConfirm.bind(this);
    this.handleBulkActionCancel = this.handleBulkActionCancel.bind(this);
    this.handleBulkActionClick = this.handleBulkActionClick.bind(this);
  }

  getIsAllChecked() {
    const { data, dataIdPath } = this.props;
    const { checkedData } = this.state;
    const matchedDataCount = data.filter(oneData => !!checkedData[get(oneData, dataIdPath)]).length;

    let isAllChecked = false;

    if (data.length) {
      if (matchedDataCount === data.length) {
        isAllChecked = true;
      } else if (matchedDataCount >= 1) {
        isAllChecked = undefined;
      }
    }

    return isAllChecked;
  }

  handleSingleChange(event, data) {
    const { checked } = event.target;
    const { checkedData } = this.state;
    const { dataIdPath, dataDescriptionPath } = this.props;

    if (checked) {
      checkedData[get(data, dataIdPath)] = get(data, dataDescriptionPath);
    } else {
      unset(checkedData, get(data, dataIdPath));
    }

    this.setState({ checkedData });
  }

  handleAllChange(event) {
    const { checked } = event.target;
    const { data, dataIdPath, dataDescriptionPath } = this.props;
    const { checkedData } = this.state;

    if (checked && this.getIsAllChecked() !== undefined) {
      forEach(data, oneData => {
        checkedData[get(oneData, dataIdPath)] = get(oneData, dataDescriptionPath);
      });
    } else {
      forEach(data, oneData => {
        unset(checkedData, get(oneData, dataIdPath));
      });
    }

    this.setState({ checkedData });
  }

  handleBulkActionClick() {
    this.setState({ isOpen: true });
  }

  handleBulkActionCancel() {
    this.setState({ isOpen: false });
  }

  async handleBulkActionConfirm() {
    const { checkedData } = this.state;
    const { action, actionCallback } = this.props;

    this.setState({ isOpen: false });
    await action(keys(checkedData));
    this.setState({ checkedData: {} });
    actionCallback();
  }

  render() {
    const { children, actionType, dataType, confirmRest, cancelRest } = this.props;
    const { checkedData, isOpen } = this.state;
    const checkedDataCount = size(checkedData);
    const isAllChecked = this.getIsAllChecked();

    const childrenWithProps = React.Children.map(children, child =>
      React.cloneElement(child, {
        isAllChecked,
        checkedData,
        checkedDataCount,
        handleAllChange: this.handleAllChange,
        handleSingleChange: this.handleSingleChange,
        handleBulkActionClick: this.handleBulkActionClick,
      })
    );

    return (
      <Fragment>
        <Dialog
          type="primary"
          title={`${capitalize(actionType)} ${dataType}(s)`}
          message={`Are you sure you want to ${actionType} the ${dataType}(s)?`}
          isOpen={isOpen}
          cancelText="No"
          confirmText="Yes"
          onCancel={this.handleBulkActionCancel}
          onConfirm={this.handleBulkActionConfirm}
          confirmRest={confirmRest}
          cancelRest={cancelRest}
          className="cirrus"
        />
        {childrenWithProps}
      </Fragment>
    );
  }
}

export default TableBulkAction;
